import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
const routes = [{
	path: "/",
	name: "login",
	component: () => import("@/views/login"),
}, {
	path: "/register",
	name: "register",
	component: () => import("@/views/register"),
}, {
	path: "/HomeView",
	name: "home",
	component: () => import("@/views/HomeView"),
}, {
	path: "/certifyInfo",
	name: "certifyInfo",
	meta: {
		index: '1'
	},
	component: () => import("@/views/HomeView"),
	children: [{
		path: '/certifyInfo/index',
		name: 'index',
		meta: {
			index: '1-1'
		},
		component: () => import( /* 企业信息 */ "@/views/certifyInfo/index"),
	},{
		path: '/certifyInfo/device',
		name: 'device',
		meta: {
			index: '1-2'
		},
		component: () => import( /* 设备管理 */ "@/views/certifyInfo/device"),
	}]
}, {
	path: "/housing",
	name: "housing",
	meta: {
		index: '2'
	},
	component: () => import("@/views/HomeView"),
	children: [{
		path: '/housing/houseType',
		name: 'houseType',
		meta: {
			index: '2-1'
		},
		component: () => import( /* 房型列表 */ "@/views/housing/houseType"),
	}, {
		path: '/housing/housingResource',
		name: 'housingResource',
		meta: {
			index: '2-2'
		},
		component: () => import( /* 房源列表 */ "@/views/housing/housingResource"),
	},{
		path: '/housing/housingPrice',
		name: 'housingPrice',
		meta: {
			index: '2-3'
		},
		component: () => import( /* 房价列表 */ "@/views/housing/housingPrice"),
	},{
		path: '/housing/houseStateRealtime',
		name: 'houseStateRealtime',
		meta: {
			index: '2-4'
		},
		component: () => import( /* 实时房态 */ "@/views/housing/houseStateRealtime"),
	},{
		path: '/housing/houseStateForward',
		name: 'houseStateForward',
		meta: {
			index: '2-5'
		},
		component: () => import( /* 远期房态 */ "@/views/housing/houseStateForward"),
	}]
}, {
	path: "/order",
	name: "order",
	meta: {
		index: '3'
	},
	component: () => import("@/views/HomeView"),
	children: [{
		path: '/order/orderlist',
		name: 'orderlist',
		meta: {
			index: '3-1'
		},
		component: () => import( /* 订单列表 */ "@/views/order/orderlist"),
	}, {
		path: '/order/addCheckIn',
		name: 'addCheckIn',
		meta: {
			index: '3-2'
		},
		component: () => import( /* 添加入住 */ "@/views/order/addCheckIn"),
	},{
		path: '/order/addreserve',
		name: 'addreserve',
		meta: {
			index: '3-3'
		},
		component: () => import( /* 添加预定 */ "@/views/order/addreserve"),
	}]
}, {
	path: "/userList",
	name: "userList",
	component: () => import("@/views/HomeView"),
	meta: {
		index: '4'
	},
	children: [{
		path: '/userList/user_center',
		name: 'user_center',
		meta: {
			index: '4-2'
		},
		component: () => import( /* 账户中心 */ "@/views/userList/user_center"),
	}, {
		path: '/userList/user_manage',
		name: 'user_manage',
		meta: {
			index: '4-1'
		},
		component: () => import( /* 管理员管理 */ "@/views/userList/user_manage"),
	}, {
		path: '/userList/user_add',
		name: 'user_add',
		meta: {
			index: '4-1'
		},
		component: () => import( /* 管理员管理-新增 */ "@/views/userList/user_add"),
	}]
},





















{
	path: "/HomeList",
	name: "HomeList",
	meta: {
		index: '2'
	},
	component: () => import("@/views/HomeView"),
	children: [{
		path: '/HomeList/index',
		name: 'index',
		meta: {
			index: '1-1'
		},
		component: () => import( /* 房源列表 */ "@/views/HomeList/index"),
	}, {
		path: '/HomeList/roomType',
		name: 'roomType',
		meta: {
			index: '1-2'
		},
		component: () => import( /* 房型列表 */ "@/views/HomeList/roomType"),
	},{
		path: '/HomeList/detail',
		name: 'detail',
		meta: {
			index: '1-3'
		},
		component: () => import( /* 房型列表 */ "@/views/HomeList/detail"),
	}]
}, {
	path: "/base",
	name: "base",
	component: () => import("@/views/HomeView"),
	children: [{
		path: '/base/address',
		name: 'address',
		meta: {
			index: '4-1'
		},
		component: () => import( /* 地址管理 */ "@/views/base/address"),
	}]
}, {
	path: "/bookRoom",
	name: "bookRoom",
	component: () => import("@/views/HomeView"),
	meta: {
		index: '4'
	},
	children: [{
		path: '/bookRoom/index',
		name: 'address',
		meta: {
			index: '5-1'
		},
		component: () => import( /* 订单管理 */ "@/views/bookRoom/index"),
	},{
		path: '/bookRoom/move-into',
		name: 'move-into',
		meta: {
			index: '5-2'
		},
		component: () => import( /* 入住登记 */ "@/views/bookRoom/move-into"),
	}]
},



];
const router = new VueRouter({
	routes,
});
export default router;